import React from 'react'
import PropTypes from 'prop-types'
import { OverlayTrigger, Popover } from 'react-bootstrap'

const _SelectedChips = ({ value, getText, onDelete, getTZ }) => {
  return (
    <div>
      {value.length ? value.map((val, idx) => {
        return (
          <div key={idx} className="btn btn-default btn-xs add-rmargin">
            <OverlayTrigger trigger={['hover', 'focus']} placement='right'
              overlay={<Popover>{val}{getTZ && getTZ(val)}</Popover>}>
              <span className="rmargin">{getText(val)}</span>
            </OverlayTrigger>&nbsp;
            <span
              className="glyphicon glyphicon-remove"
              onClick={() => { onDelete(val) }} />
          </div>
        )
      }) : null
      }
    </div>
  )
}
_SelectedChips.propTypes = {
  value: PropTypes.array.isRequired,
  getText: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
}
export default _SelectedChips
